import React, { useState, useEffect } from 'react';
import { getOrders } from '../api';

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getOrders()
      .then(d => { setOrders(d.orders || []); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  if (loading) return <div style={{ padding: 40, color: 'var(--t3)' }}>Loading orders...</div>;
  if (error) return <div style={{ padding: 40, color: 'var(--red)' }}>Error: {error}</div>;
  if (!orders.length) return (
    <div>
      <h1 style={s.h1}>Order History</h1>
      <div style={{ textAlign: 'center', padding: '60px 40px', background: 'var(--bg-1)', borderRadius: 'var(--rl)', border: '1px solid var(--border)' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>No Orders Yet</div>
        <div style={{ fontSize: 13, color: 'var(--t3)' }}>Approved orders from the Order Review page will appear here.</div>
      </div>
    </div>
  );

  return (
    <div>
      <h1 style={s.h1}>Order History</h1>
      <p style={s.sub}>{orders.length} orders from Alpaca</p>

      <div style={s.table}>
        <div style={s.thead}>
          <span style={{ width: 90 }}>Date</span>
          <span style={{ width: 70 }}>Symbol</span>
          <span style={{ width: 50 }}>Side</span>
          <span style={{ width: 40, textAlign: 'right' }}>Qty</span>
          <span style={{ width: 80, textAlign: 'right' }}>Price</span>
          <span style={{ width: 80 }}>Type</span>
          <span style={{ width: 70 }}>Status</span>
        </div>
        {orders.map((o, i) => (
          <div key={o.id || i} style={s.trow}>
            <span style={{ width: 90, color: 'var(--t3)' }}>{(o.submitted_at || '').slice(0, 10)}</span>
            <span style={{ width: 70, fontWeight: 600 }}>{o.symbol}</span>
            <span style={{
              width: 50, fontSize: 11, fontWeight: 700,
              color: o.side === 'BUY' ? 'var(--green)' : 'var(--red)',
            }}>{o.side}</span>
            <span style={{ width: 40, textAlign: 'right' }}>{o.qty}</span>
            <span style={{ width: 80, textAlign: 'right' }}>{o.price ? `$${o.price.toFixed(2)}` : '—'}</span>
            <span style={{ width: 80, fontSize: 11 }}>{o.type}</span>
            <span style={{ width: 70 }}>
              <span style={{
                ...s.statusPill,
                background: o.status === 'FILLED' ? 'var(--green-bg)' : 'var(--amber-bg)',
                color: o.status === 'FILLED' ? 'var(--green)' : 'var(--amber)',
              }}>{o.status}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

const s = {
  h1: { fontSize: 22, fontWeight: 700, marginBottom: 4 },
  sub: { fontSize: 13, color: 'var(--t3)', marginBottom: 24 },
  table: {
    background: 'var(--bg-1)', borderRadius: 'var(--rl)', border: '1px solid var(--border)', overflow: 'hidden',
  },
  thead: {
    display: 'flex', gap: 12, padding: '12px 24px',
    fontSize: 11, fontWeight: 600, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: 1,
    borderBottom: '1px solid var(--border-s)', background: 'var(--bg-2)',
  },
  trow: {
    display: 'flex', gap: 12, padding: '14px 24px', fontSize: 13,
    borderBottom: '1px solid var(--border-s)', alignItems: 'center',
  },
  statusPill: {
    fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 4,
  },
};
